import PropTypes from 'prop-types';
import React from 'react';

import SelectedAnswerHistoryItemContainer from 'presentation/containers/__demo__/SelectedAnswerHistoryItemContainer';
import EndMessageContainer from 'presentation/containers/EndMessageContainer';
import Message, { Communicators } from 'presentation/components/Message';
import MessageStack from 'presentation/components/MessageStack';
import TypingIndicator from 'presentation/components/TypingIndicator';
import WelcomeMessageContainer from 'presentation/containers/WelcomeMessageContainer';

import styles from 'presentation/components/styles/ChatHistory.css';

class ChatHistory extends React.Component {
  constructor(props) {
    super(props);

    const chatHistoryPropTypes = {
      isAgentTyping: PropTypes.bool,
      isChatEnded: PropTypes.bool.isRequired,
      isDemoSelfServiceEnabled: PropTypes.bool.isRequired,
      messageHistory: PropTypes.array,
    };
    PropTypes.checkPropTypes(chatHistoryPropTypes, props, 'prop', 'ChatHistory');
  }

  componentDidUpdate() {
    this.containerElement.scrollTop = this.containerElement.scrollHeight;
  }

  componentDidMount() {
    this.containerElement.scrollTop = this.containerElement.scrollHeight;
  }

  renderMessageHistory() {
    let renderedHistory = [];
    let renderedMessages = [];

    this.props.messageHistory.forEach((message, index, messages) => {
      let sender = getSender(message);
      let nextSender = getSender(messages[index + 1]);
      renderedMessages.push(<Message sender={sender} content={message.content.body} key={message.id} />);

      if (sender !== nextSender || message._hasError) {
        renderedHistory.push(
          <MessageStack
            key={index}
            timestamp={message.date}
            hasError={message._hasError}
            sender={sender}
            messages={renderedMessages}
          />
        );
        renderedMessages = [];
      }
    });
    return renderedHistory;
  }

  // get length of the rendered history and if its the agent is the last, when you render that the agent is typing, remove the timestamp

  render() {
    return (
      <div
        role="textbox"
        tabIndex="0"
        data-aid="gladlyChatHistoryList"
        className={styles.chatHistory_wrapper}
        ref={div => (this.containerElement = div)}
      >
        <div className={styles.chatHistory} tabIndex="-1">
          {this.props.isDemoSelfServiceEnabled && <SelectedAnswerHistoryItemContainer />}
          <WelcomeMessageContainer />
          {this.renderMessageHistory()}
          {this.props.isAgentTyping ? <TypingIndicator /> : null}
          {this.props.isChatEnded ? <EndMessageContainer /> : null}
        </div>
      </div>
    );
  }
}

function getSender(message) {
  if (!message) {
    return null;
  }
  return message.isUser ? Communicators.CUSTOMER : Communicators.AGENT;
}

export default ChatHistory;
